module.exports = __webpack_public_path__ + "static/certificate2-438035229d7937d2245aa7140f7a7461.jpg";